import {Backdrop, CircularProgress, keyframes, Stack, styled, Typography} from '@mui/material'

export const StyledBackdrop = styled(Backdrop)(({theme}) => ({
  zIndex: theme.zIndex.drawer + 1,
  '&.MuiBackdrop-invisible': {
    pointerEvents: 'none',
  },
}))

export const StyledProgress = styled(CircularProgress)(({theme}) => ({
  borderRadius: 999,
  backgroundColor: `#FFFFFF`,
  color: theme.palette.primary.main,
}))

const pulsePadding = keyframes`
  0% {
    padding: 0px;
  }
  50% {
    padding: 10px;
  }
  100% {
    padding: 0px;
  }
`

export const LoaderWrapper = styled(Stack)(() => ({
  flexDirection: 'row',
  backgroundColor: `#FFFFFF33`,
  borderRadius: 999,
  alignItems: 'center',
  animation: `${pulsePadding} 1.2s ease-in-out infinite`,
}))

export const LoaderText = styled(Typography)(() => ({
  paddingLeft: '0.75rem',
  paddingRight: '0.75rem',
}))
